module.exports = __webpack_public_path__ + "static/media/fifteen.95f0b59b.jpg";